import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WorkflowDocuments from './workflow-documents';
import WorkflowDocumentsDetail from './workflow-documents-detail';
import WorkflowDocumentsUpdate from './workflow-documents-update';
import WorkflowDocumentsDeleteDialog from './workflow-documents-delete-dialog';

const WorkflowDocumentsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WorkflowDocuments />} />
    <Route path="new" element={<WorkflowDocumentsUpdate />} />
    <Route path=":id">
      <Route index element={<WorkflowDocumentsDetail />} />
      <Route path="edit" element={<WorkflowDocumentsUpdate />} />
      <Route path="delete" element={<WorkflowDocumentsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WorkflowDocumentsRoutes;
